export default "__VITE_ASSET__BTbpfskG__"